<template>
    <PPage title="Sales Boosting" :primaryAction="{
        content: 'Save',
        onAction: saveConfig,
        loading: loading,
        disabled: !canSave
      }" :secondaryActions="[{
        content: 'Reset Settings', 
        onAction: reset
      }]">
    <Analytics />
    <br>
    <PLayout>
  <PLayoutAnnotatedSection
    title="Social Proof Popup"
    description="The social proof popup helps to build trust by showing recent sale notifications done by real humans.">
    <PCard sectioned title="General Settings">
      <PFormLayout>
      <PTextField v-model="saleEventCount" type="number" id="input_field1" label="How many Popups are shown per User Session?" suffix="Popups" help-text="The maximum number the popup is shown per unique pageviews. For example, if set to 12, we’ll show 12 popups per unique pageview." @change="handleChange" />
      </PFormLayout>
    </PCard>
    <PCard sectioned title="Language Settings">
      <PFormLayout>
        <PTextField label="First line of sale popup?" v-model="line1" type="text" id="text_field1" :help-text="`You can use placeholders {{firstName}}, {{city}} and {{product}}.`" />
        <PTextField label="Second line of sale popup?" v-model="line2" type="text" id="text_field2" :help-text="`You can use placeholders {{firstName}}, {{city}} and {{product}}.`" />
      </PFormLayout>
    </PCard>
    <PCard sectioned title="Delay Settings">
      <PFormLayout>
      <PTextField v-model="initialDelaySec" type="number" id="input_field2" label="Initial Delay" suffix="Seconds" help-text="Time delay in seconds, on when to show the first notification. Set this to 0 to display it right away." @change="handleChange" />
      <PTextField v-model="pauseDelaySec" type="number" id="input_field3" label="Delay between Popups" suffix="Seconds" help-text="How long the delay should last between notifications in seconds. Minimum 10 seconds is recommended." @change="handleChange" />
      <PTextField v-model="showDelaySec" type="number" id="input_field4" label="How long are Popups shown?" suffix="Seconds" help-text="This time indicates the total duration one popup window is visible (in seconds). Duration of animation included." @change="handleChange" />
      </PFormLayout>
    </PCard>
  </PLayoutAnnotatedSection>
</PLayout>
 
    </PPage>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import {db, functions} from '@/firebase.js'
import Analytics from '@/components/Analytics'


export default {
  name: 'Home',
  components: {
    Analytics
  },
  computed: {
    canSave() {
      return true
    },
    initialDelaySec: {
      get(){
        return this.initialDelay / 1000
      },
      set(initialDelay){
        this.initialDelay = initialDelay * 1000
      }
    },
    pauseDelaySec: {
      get(){
        return this.pauseDelay / 1000
      },
      set(pauseDelay){
        this.pauseDelay = pauseDelay * 1000
      }
    },
    showDelaySec: {
      get(){
        return this.showDelay / 1000
      },
      set(showDelay){
        this.showDelay = showDelay * 1000
      }
    }
  },
  methods: {
    async saveConfig(){
      this.loading = true
      await functions.httpsCallable('editSettings')({
        shop: this.$route.query.shop,
        myAuth: this.$route.query.myAuth,
        config:{
        showDelay: this.showDelay,
        pauseDelay: this.pauseDelay,
        initialDelay: this.initialDelay,
        saleEventCount: this.saleEventCount,
        line1: this.line1,
        line2: this.line2
      }})
      this.loading = false
    },
    reset(){
      this.showDelay = 10000
      this.pauseDelay = 15000
      this.initialDelay = 5000
      this.saleEventCount = 8
      this.line1 = '{{ firstName | gdpr }} from {{city}}'
      this.line2 = 'just bought {{ product }}'
    },
     handleChange(val) {
      this.val = val;
    }
  },
  async mounted() {
    global.__DEBUG_bs = this
    let {showDelay, pauseDelay, initialDelay, saleEventCount, line1, line2} = (await db.doc("/shops/" + this.$route.query.shop + "/output/__CONFIG").get()).data()
    this.showDelay = showDelay
    this.pauseDelay = pauseDelay
    this.initialDelay = initialDelay
    this.saleEventCount = saleEventCount
    this.line1 = line1
    this.line2 = line2
  },
  data(){
    return {
      loading: false,
      showDelay: 10000,
      pauseDelay: 15000,
      initialDelay: 5000,
      saleEventCount: 8,
      line1: '{{ firstName | gdpr }} from {{city}}',
      line2: 'just bought {{ product }}'
    }
  }
}
</script>
